
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 22 26"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 707"}},[_c('g',{attrs:{"data-name":"weapons (1)"}},[_c('path',{attrs:{"data-name":"Path 94","d":"M21.455 3.092L11.22.032a.767.767 0 00-.439 0L.545 3.092a.762.762 0 00-.545.73V15.04a7.231 7.231 0 001.762 4.44 18.188 18.188 0 003.671 3.388 32.976 32.976 0 005.254 3.065.767.767 0 00.625 0 32.976 32.976 0 005.254-3.065 18.191 18.191 0 003.667-3.389 7.231 7.231 0 001.762-4.44V3.821a.762.762 0 00-.54-.729z","fill":"#1B342C"}}),_c('path',{attrs:{"data-name":"Path 95","d":"M21.455 3.092L11.22.032A.767.767 0 0011 0v26a.766.766 0 00.312-.067 32.976 32.976 0 005.254-3.065 18.192 18.192 0 003.672-3.389A7.231 7.231 0 0022 15.04V3.821a.762.762 0 00-.545-.729z","fill":"#1BB58B"}})]),_c('g',{attrs:{"data-name":"weapons (1)","fill":"#74DBB5"}},[_c('path',{attrs:{"data-name":"Path 94","d":"M15.252 9.189l-3.937-1.177a.3.3 0 00-.169 0L7.21 9.189A.293.293 0 007 9.47v4.314a2.781 2.781 0 00.678 1.708 7 7 0 001.412 1.3 12.683 12.683 0 002.021 1.179.295.295 0 00.24 0 12.683 12.683 0 002.021-1.171 7 7 0 001.412-1.3 2.781 2.781 0 00.678-1.708V9.47a.293.293 0 00-.21-.281z"}}),_c('path',{attrs:{"data-name":"Path 95","d":"M15.252 9.189l-3.936-1.177A.3.3 0 0011.231 8v10a.294.294 0 00.12-.026 12.682 12.682 0 002.021-1.174 7 7 0 001.412-1.3 2.781 2.781 0 00.678-1.708V9.47a.293.293 0 00-.21-.281z"}})])])])
          )
        }
      }
    